@if (impersonation.isImpersonating()) {
  <div class="impersonation-banner" role="status" aria-live="polite">
    <mat-icon class="impersonation-banner__icon" aria-hidden="true">switch_account</mat-icon>
    <span class="impersonation-banner__text">
      You are impersonating <strong>{{ impersonation.getImpersonatedName() }}</strong>
    </span>
    <button mat-stroked-button class="impersonation-banner__stop"
            (click)="impersonation.stop()">
      <mat-icon aria-hidden="true">logout</mat-icon>
      Stop impersonating
    </button>
  </div>
}
@if (loadingService.loading$ | async) {
  <mat-progress-bar class="top-loading-bar" mode="indeterminate"></mat-progress-bar>
}
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
               [fixedTopGap]="impersonation.isImpersonating() ? 57 : 0"
               [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
               [mode]="(isHandset$ | async) ? 'over' : 'side'"
               [opened]="(isHandset$ | async) === false" >
    <app-side-menu class="side-menu"></app-side-menu>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-top-bar (toggleDrawer)="drawer.toggle()"></app-top-bar>
  </mat-sidenav-content>
</mat-sidenav-container>
<main class="main-content">
  <router-outlet></router-outlet>
</main>
